import { HttpClient, JSON_STRING } from "../../../services/http/http-client";
import { SETTINGS_URL, ACCOUNTING_URL } from "../../../services/common-urls";

export const GeneralSettingService = {
  findTerritoryDetails: () => HttpClient.post(SETTINGS_URL, {
    section: 'generalsettings',
    output: JSON_STRING,
  }),
  updateExchangeRates: () => HttpClient.post(ACCOUNTING_URL, {
    section: 'currencies',
    action: 'update_exchange_rates',
    output: JSON_STRING,
  }),
  findCurrencies: () => HttpClient.post(ACCOUNTING_URL, {
    section: 'currencies',
    action: 'load_currencies_table',
    output: JSON_STRING,
  }),
  insertNewCurrency: ({
    currency_iso,
    currency_name,
    exchange_rate,
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'currencies',
    action: 'add_currency',
    currency_iso,
    currency_name,
    exchange_rate,
  }),
  findTerritories: () => HttpClient.post(SETTINGS_URL, {
    section: 'generalsettings',
    action: 'get_territories',
  }),
  findTerritory: ({
    territory_id
  } = {}) => HttpClient.post(SETTINGS_URL, {
    section: 'generalsettings',
    action: 'get_territory',
    territory_id,
  }),
  insertNewTerritory: ({
    territory_id = '',
    territory_name,
    countries = '[]'
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'generalsettings',
    action: 'add_edit_territory',
    territory_id,
    countries,
    territory_name,
  }),
  removeTerritory: ({
    territory_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'generalsettings',
    action: 'remove_territory',
    territory_id
  }),
  removeCurrency: ({
    currency_id
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'currencies',
    action: 'delete_currency',
    currency_id
  })
}